import { render, staticRenderFns } from "./MenuTriangle.vue?vue&type=template&id=3c437d16&scoped=true&"
import script from "./MenuTriangle.vue?vue&type=script&lang=js&"
export * from "./MenuTriangle.vue?vue&type=script&lang=js&"
import style0 from "./MenuTriangle.vue?vue&type=style&index=0&id=3c437d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c437d16",
  null
  
)

export default component.exports